var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.9164V10H2.08362L8.23168 3.85193L6.14806 1.76831L0 7.9164Z",
    fill: "#4247C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83751 1.45992L8.5401 0.162522C8.3234 -0.0541741 7.97056 -0.0541741 7.75387 0.162522L6.73706 1.17933L8.82068 3.26295L9.83749 2.24614C10.0542 2.02945 10.0542 1.67661 9.83751 1.45992Z",
    fill: "#4247C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.111c4cce2f3f2974feb2e3e4b0804468.svg";
export { ForwardRef as ReactComponent };